import { BadgeCheck, Clock } from "lucide-react";

export default function QualityPolicies() {
  return (
    <section id="quality" className="bg-slate-800/30 py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3">
            Nuestros estándares
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            <span className="text-orange-500">Certificaciones</span> y Normas
          </h2>
          <p className="text-slate-400 max-w-xl mx-auto text-base leading-relaxed">
            Trabajamos bajo normativas internacionales que avalan la calidad y
            seguridad de cada proyecto.
          </p>
        </div>

        {/* Single Card - ISO 9001 */}
        <div className="max-w-lg mx-auto">
          <div className="group relative bg-slate-900/60 border border-slate-700/50 rounded-xl p-8 hover:border-green-500/40 hover:bg-slate-900/80 transition-all duration-300 hover:shadow-xl hover:shadow-green-500/5">
            {/* Certificate Image */}
            <div className="bg-slate-800/80 border border-slate-700/50 rounded-lg mb-6 overflow-hidden">
              <img
                src="https://ilkpzxkwhjwvollmxurg.supabase.co/storage/v1/object/public/proyectos/ISO9001.jpeg"
                alt="Certificado ISO 9001:2015"
                className="w-full h-auto object-contain"
              />
            </div>

            {/* Title */}
            <h3 className="text-white font-bold text-xl mb-3 group-hover:text-green-400 transition-colors">
              Política de Calidad
            </h3>

            {/* Badge */}
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full border mb-5 bg-green-500/10 border-green-500/30 text-green-400">
              <BadgeCheck size={14} />
              ISO 9001:2015
            </span>

            {/* Description */}
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Sistema de gestión basado en la norma internacional ISO 9001:2015.
            </p>

            {/* Status */}
            <div className="flex items-center gap-2 pt-4 border-t border-slate-700/50">
              <Clock size={14} className="text-green-400" />
              <span className="text-xs font-semibold uppercase tracking-wide text-green-400">
                Certificado
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
